import AreaContainer from "../AreaContainer";
import styles from './demographics.module.css';
import globalStyles from '../result.module.css';

type props = {
  features: Feature,
  portfolio: {
    styles: {
      main: string
    }
  }
}

interface Feature {
  [key: string]: {
    value: any;
    label: string
  };
}

type Stat = {
  title: string,
  value: string
}

const Demographics = ({ features, portfolio }: props) => {
  let demoText = '';

  if (features.demographics) {
    demoText = features.demographics.value
  }

  const allowedStats = [
    "annual_footfall",
    "dwell_time",
    "people_within_walking_distance",
    "catchment_area",
    "avg_spend",
    "dwell_time",
  ];

  const stats: Stat[] = [];

  Object.keys(features).forEach((feature) => {
    if (allowedStats.includes(feature)) {
      let append = "";
      let prepend = "";

      switch (feature) {
        case "catchment_area":
          append = "miles sq";
          break;
        case "avg_spend":
          prepend = "£";
          break;
        case "dwell_time":
          append = "m";
          break;
        default:
          break;
      }

      let value = /^[0-9]+$/.test(features[feature].value)
        ? Number(features[feature].value).toLocaleString()
        : features[feature].value;

      stats.push({
        title: features[feature].label,
        value: `${prepend} ${value} ${append}`,
      });
    }
  });

  if (stats.length == 0 && (demoText !== null && demoText === '') && features.insights == null) {
    return null;
  }
  return (
    <AreaContainer area="demographics" style={null} extraClass={null}>
      <div>
        {(stats.length > 0 || (demoText !== null && demoText !== '')) && (
          <div className={styles.DemoWrapper}>
            <h2 className={globalStyles.subTitleText}>Demographics</h2>
            {demoText && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} dangerouslySetInnerHTML={{ __html: demoText }}></p>}
            {stats.length > 0 && (
              <div className={styles.statHolder} >
                {stats.map((stat, i) => {
                  return (
                    <div className={styles.stat} key={i}>
                      <div className={globalStyles.subTitleText} style={{ color: portfolio?.styles?.main ? portfolio.styles.main : '#E34963' }}>{stat.value}</div>
                      <div className={`${globalStyles.smallText} ${globalStyles.lightColorText}`}>{stat.title}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
        {features.insights && (
          <div className={styles.DemoWrapper}>
            <h2 className={`${globalStyles.subTitleText} ${globalStyles.morePadding}`}>Insights</h2>
            <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight} ${styles.preWrap}`} dangerouslySetInnerHTML={{ __html: features.insights.value }}></p>
          </div>
        )}

      </div>
    </AreaContainer>
  );
};

export default Demographics;
